<div class="gateway-container">
  <accordion class="gateway-accordion flex-fill-width">
    <accordion-group
      [isOpen]="item.isOpen"
      [ngClass]="{ isOpen: item.isOpen }"
      (isOpenChange)="isOpenChange($event)"
    >
      <button
        class="btn btn-link btn-block clearfix accordion-head"
        accordion-heading
        type="button"
      >
        <div class="pull-left float-left">{{ getHeadingGateway() }}</div>
        <span class="float-right pull-right">
          <i
            class="fa"
            [ngClass]="{
              'fa-caret-down': !item.isOpen,
              'fa-caret-up': item.isOpen
            }"
          ></i>
        </span>
      </button>
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <label for="" *ngIf="type == 'gateway'">
              {{ 'ADMIN_LTI.GATEWAYS.BODY.GATEWAY' | translate }}
            </label>
            <label for="" *ngIf="type == 'objective'">
              {{ 'ADMIN_LTI.GATEWAYS.BODY.OBJECTIVE' | translate }}
            </label>
            <label for="" *ngIf="type == 'corrective'">
              {{ 'ADMIN_LTI.GATEWAYS.BODY.CORRECTIVE' | translate }}
            </label>
            <select
              [disabled]="IsActive"
              class="form-control"
              name="GoalId"
              [(ngModel)]="item['GoalId']"
              (ngModelChange)="onGoalChange($event)"
            >
              <option [ngValue]="undefined">
                <span *ngIf="type == 'gateway'">
                  {{ 'ADMIN_LTI.GATEWAYS.BODY.SELECT_GATEWAY' | translate }}
                </span>
                <span *ngIf="type == 'objective'">
                  {{ 'ADMIN_LTI.GATEWAYS.BODY.SELECT_OBJECTIVE' | translate }}
                </span>
                <span *ngIf="type == 'corrective'">
                  {{ 'ADMIN_LTI.GATEWAYS.BODY.SELECT_CORRECTIVE' | translate }}
                </span>
              </option>
              <option value="{{ goal.Id }}" *ngFor="let goal of item.goals">
                {{ goal.Name }}
              </option>
            </select>
          </div>
        </div>

        <div class="gat_settings col-xs-6">
          <div class="gat_selection">
            <div class="display-flex-left">
              <div class="form-group" *ngIf="item['GoalId']">
                <label for="">
                  {{ 'ADMIN_LTI.GATEWAYS.BODY.MEASURE' | translate }}
                </label>
                <select
                  [disabled]="IsActive"
                  class="form-control"
                  name="MeasureId"
                  [(ngModel)]="item['MeasureId']"
                  (ngModelChange)="onMeasureChange($event)"
                >
                  <option [ngValue]="undefined">
                    {{ 'ADMIN_LTI.GATEWAYS.BODY.SELECT_MEASURE' | translate }}
                  </option>
                  <option
                    value="{{ measure.Id }}"
                    *ngFor="let measure of item.measures"
                  >
                    {{ measure.Name }}
                  </option>
                </select>
              </div>

              <div
                class="form-group"
                *ngIf="
                  currentMeasureObj && currentMeasureObj.MeasureType === 'money'
                "
              >
                <label for="">&nbsp;</label>
                <input
                  [disabled]="IsActive"
                  type="text"
                  name="Currency"
                  [(ngModel)]="item['Currency']"
                  class="form-control"
                />
              </div>

              <div
                class="form-group"
                *ngIf="
                  currentMeasureObj &&
                  (currentMeasureObj.MeasureType === 'money' ||
                    currentMeasureObj.MeasureType === 'int') &&
                  item['formats']
                "
              >
                <label for="">
                  {{ 'ADMIN_LTI.GATEWAYS.BODY.FORMAT' | translate }}
                </label>
                <select
                  [disabled]="IsActive"
                  class="form-control"
                  name="FormatId"
                  [(ngModel)]="item['FormatId']"
                  (ngModelChange)="onFormatChange($event)"
                >
                  <option [ngValue]="undefined">
                    {{ 'ADMIN_LTI.GATEWAYS.BODY.SELECT_FORMAT' | translate }}
                  </option>
                  <option
                    value="{{ format.Id }}"
                    *ngFor="let format of item.formats"
                  >
                    {{ format.Name }}
                  </option>
                </select>
              </div>

              <div
                class="form-group"
                *ngIf="
                  currentMeasureObj &&
                  currentMeasureObj.MeasureType === 'scale' &&
                  item['scales']
                "
              >
                <label for="">
                  {{ 'ADMIN_LTI.GATEWAYS.BODY.SCALES' | translate }}
                </label>
                <select
                  [disabled]="IsActive"
                  class="form-control"
                  name="ScaleId"
                  [(ngModel)]="item['ScaleId']"
                  (ngModelChange)="onScaleChange($event)"
                >
                  <option [ngValue]="undefined">
                    {{ 'ADMIN_LTI.GATEWAYS.BODY.SELECT_SCALES' | translate }}
                  </option>
                  <option
                    value="{{ scale.Id }}"
                    *ngFor="let scale of item.scales"
                  >
                    {{ scale.Name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="form-group">
              <label for="">
                {{ 'ADMIN_LTI.GATEWAYS.BODY.WEIGHT' | translate }}
              </label>
              <div class="input-group">
                <input
                  [disabled]="IsActive"
                  OnlyInteger="true"
                  type="text"
                  name="Weight"
                  [(ngModel)]="item['Weight']"
                  class="input_small form-control"
                />
                <div class="input-group-prepend">
                  <span class="input-group-text">%</span>
                </div>
              </div>
            </div>
          </div>
          <div class="gat_descriptiion">
            <div class="form-group">
              <label for="">
                {{ 'ADMIN_LTI.GATEWAYS.BODY.DESCRIPTION' | translate }}
              </label>
              <textarea
                [disabled]="IsActive"
                autosize
                type="text"
                name="Name"
                [(ngModel)]="item['Name']"
                class="form-control autosize"
              ></textarea>
            </div>
          </div>
          <div
            class="form-check"
            *ngIf="
              currentMeasureObj && currentMeasureObj.MeasureType !== 'enum'
            "
          >
            <input
              [disabled]="IsActive"
              class="form-check-input magic-checkbox"
              [(ngModel)]="item['IsCorridor']"
              type="checkbox"
              id="IsCorridor_{{ type }}_{{ index }}"
            />
            <label
              class="form-check-label"
              for="IsCorridor_{{ type }}_{{ index }}"
            >
              {{ 'ADMIN_LTI.GATEWAYS.BODY.CORRIDOR' | translate }}
            </label>
          </div>
          <div
            class="gat_corridor"
            [ngClass]="{ selectedCorridor: item['IsCorridor'] }"
            *ngIf="
              currentMeasureObj && currentMeasureObj.MeasureType !== 'enum'
            "
          >
            <div class="gat_corridor_checked" *ngIf="item['IsCorridor']">
              <div class="">
                <div class="objective_values text-center">
                  {{ 'ADMIN_LTI.GATEWAYS.BODY.OBJECTIVE_VALUE' | translate }}
                </div>
                <div class="display-flex-left">
                  <div class="form-group">
                    <label for="" class="delta">
                      <span *ngIf="currentMeasureObj.MeasureType == 'scale'">
                        &#916;
                      </span>
                      &nbsp;{{ 'MIN' | translate }}
                    </label>
                    <div class="input-group">
                      <div
                        *ngIf="currentMeasureObj.MeasureType == 'scale'"
                        class="input-group-prepend"
                      >
                        <span
                          class="input-group-text"
                          style="
                            background: transparent !important;
                            border: 0px !important;
                          "
                        >
                          <i class="fa fa-minus"></i>
                        </span>
                      </div>
                      <input
                        [disabled]="IsActive"
                        OnlyInteger="true"
                        type="text"
                        name="Min"
                        [(ngModel)]="item['Min']"
                        class="input_small form-control"
                      />
                      <div *ngIf="NotScale" class="input-group-prepend">
                        <span class="input-group-text">%</span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="" class="delta">
                      <span *ngIf="currentMeasureObj.MeasureType == 'scale'">
                        &#916;
                      </span>
                      &nbsp;{{ 'MAX' | translate }}
                    </label>
                    <div class="input-group">
                      <div
                        *ngIf="currentMeasureObj.MeasureType == 'scale'"
                        class="input-group-prepend"
                      >
                        <span
                          class="input-group-text"
                          style="
                            background: transparent !important;
                            border: 0px !important;
                          "
                        >
                          <i class="fa fa-plus"></i>
                        </span>
                      </div>
                      <input
                        [disabled]="IsActive"
                        OnlyInteger="true"
                        type="text"
                        name="Max"
                        [(ngModel)]="item['Max']"
                        class="input_small form-control"
                      />
                      <div *ngIf="NotScale" class="input-group-prepend">
                        <span class="input-group-text">%</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="">
                <div class="target_bonus text-center">
                  {{ 'ADMIN_LTI.GATEWAYS.BODY.TARGET_BONUS' | translate }}
                </div>
                <div class="display-flex-left">
                  <div class="form-group">
                    <label for="">
                      {{ 'ADMIN_LTI.GATEWAYS.BODY.FLOOR' | translate }}
                    </label>
                    <div class="input-group">
                      <input
                        [disabled]="IsActive"
                        OnlyInteger="true"
                        type="text"
                        name="Floor"
                        [(ngModel)]="item['Floor']"
                        class="input_small form-control"
                      />
                      <div class="input-group-prepend">
                        <span class="input-group-text">%</span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="">
                      {{ 'ADMIN_LTI.GATEWAYS.BODY.CAP' | translate }}
                    </label>
                    <div class="input-group">
                      <input
                        [disabled]="IsActive"
                        OnlyInteger="true"
                        type="text"
                        name="Cap"
                        [(ngModel)]="item['Cap']"
                        class="input_small form-control"
                      />
                      <div class="input-group-prepend">
                        <span class="input-group-text">%</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="gat_consultation_type col-xs-6"
          *ngIf="currentMeasureObj && currentMeasureObj.ConsultationMode > 0"
        >
          <div class="">
            <div class="gat_consultation_type_title">
              {{ 'ADMIN_LTI.GATEWAYS.BODY.CONSULTATION_TYPE' | translate }}
            </div>
            <div class="display-flex-left">
              <div class="form-check" *ngIf="checkVisible(4)">
                <input
                  [disabled]="IsActive"
                  [ngModel]="item['ConsultationType']"
                  class="form-check-input magic-radio"
                  name="ConsultationType_{{ type }}_{{ index }}"
                  type="radio"
                  id="Punctual_{{ type }}_{{ index }}"
                  value="Punctual"
                />
                <label
                  class="form-check-label"
                  for="Punctual_{{ type }}_{{ index }}"
                  (click)="
                    setChecked('#Punctual_' + type + '_' + index, 'Punctual')
                  "
                >
                  {{ 'ADMIN_LTI.GATEWAYS.BODY.PUNCTUAL' | translate }}
                </label>
              </div>
              <div class="form-check" *ngIf="checkVisible(2)">
                <input
                  [disabled]="IsActive"
                  [ngModel]="item['ConsultationType']"
                  class="form-check-input magic-radio"
                  name="ConsultationType_{{ type }}_{{ index }}"
                  type="radio"
                  id="Cumulative_{{ type }}_{{ index }}"
                  value="Cumulative"
                />
                <label
                  class="form-check-label"
                  for="Cumulative_{{ type }}_{{ index }}"
                  (click)="
                    setChecked(
                      '#Cumulative_' + type + '_' + index,
                      'Cumulative'
                    )
                  "
                >
                  {{ 'ADMIN_LTI.GATEWAYS.BODY.CUMULATIVE' | translate }}
                </label>
              </div>
              <div class="form-check" *ngIf="checkVisible(1)">
                <input
                  [disabled]="IsActive"
                  [ngModel]="item['ConsultationType']"
                  class="form-check-input magic-radio"
                  name="ConsultationType_{{ type }}_{{ index }}"
                  type="radio"
                  id="Average_{{ type }}_{{ index }}"
                  value="Average"
                />
                <label
                  class="form-check-label"
                  for="Average_{{ type }}_{{ index }}"
                  (click)="
                    setChecked('#Average_' + type + '_' + index, 'Average')
                  "
                >
                  {{ 'ADMIN_LTI.GATEWAYS.BODY.AVERAGE' | translate }}
                </label>
              </div>
            </div>
          </div>
          <div class="table-container">
            <table
              class="consultationTypeTable"
              *ngIf="item['ConsultationType'] == 'Punctual'"
            >
              <!-- PUNCTUAL -->
              <thead>
                <tr>
                  <th>{{ 'ADMIN_LTI.GATEWAYS.BODY.YEAR' | translate }}</th>
                  <th *ngFor="let x of item.YearlyValues">{{ x.Year }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ 'ADMIN_LTI.GATEWAYS.BODY.YEARLY_VALUE' | translate }}
                  </td>
                  <td *ngFor="let x of item.YearlyValues">
                    <input
                      [(ngModel)]="x.TargetValue"
                      type="number"
                      id="Value_{{ x.Yyear }}"
                      [disabled]="!isEditable(x.Year)"
                      class="form-control input_small"
                      [ngClass]="{ invalid: x.hasError }"
                      (ngModelChange)="onValueChange(x)"
                    />
                  </td>
                </tr>
                <tr *ngIf="errorMessage" class="errorMessage">
                  <td [attr.colspan]="item.YearlyValues.length + 1">
                    <div class="errorConsultation">
                      <i class="fa fa-exclamation text-danger"></i>
                      {{ errorMessage }}
                    </div>
                  </td>
                </tr>
                <tr *ngIf="item['IsCorridor']">
                  <td>{{ 'ADMIN_LTI.GATEWAYS.BODY.MIN' | translate }}</td>
                  <td class="text-right" *ngFor="let year of item.YearlyValues">
                    {{ formatValue(item, getMinValue(item, year), 1) }}
                  </td>
                </tr>
                <tr *ngIf="item['IsCorridor']">
                  <td>{{ 'ADMIN_LTI.GATEWAYS.BODY.MAX' | translate }}</td>
                  <td class="text-right" *ngFor="let year of item.YearlyValues">
                    {{ formatValue(item, getMaxValue(item, year), 1) }}
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              class="consultationTypeTable"
              *ngIf="item['ConsultationType'] == 'Cumulative'"
            >
              <!-- CUMULATIVE -->
              <thead>
                <tr>
                  <th>{{ 'ADMIN_LTI.GATEWAYS.BODY.YEAR' | translate }}</th>
                  <th *ngFor="let x of item.YearlyValues">{{ x.Year }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ 'ADMIN_LTI.GATEWAYS.BODY.YEARLY_VALUE' | translate }}
                  </td>
                  <td class="text-right" *ngFor="let x of item.YearlyValues">
                    <input
                      [(ngModel)]="x.TargetValue"
                      type="number"
                      id="Value_{{ x.Year }}"
                      [disabled]="!isEditable(x.Year)"
                      class="form-control input_small"
                      [ngClass]="{ invalid: x.hasError }"
                      (ngModelChange)="onValueChange(x)"
                    />
                  </td>
                </tr>
                <tr *ngIf="errorMessage" class="errorMessage">
                  <td [attr.colspan]="item.YearlyValues.length + 1">
                    <div class="errorConsultation">
                      <i class="fa fa-exclamation text-danger"></i>
                      {{ errorMessage }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    {{ 'ADMIN_LTI.GATEWAYS.BODY.TARGET_VALUE' | translate }}
                  </td>
                  <td class="text-right" *ngFor="let year of item.YearlyValues">
                    {{ formatValue(item, getTargetValue(item, year), 1) }}
                  </td>
                </tr>
                <tr *ngIf="item['IsCorridor']">
                  <td>{{ 'ADMIN_LTI.GATEWAYS.BODY.MIN' | translate }}</td>
                  <td class="text-right" *ngFor="let year of item.YearlyValues">
                    {{ formatValue(item, getMinValue(item, year), 1) }}
                  </td>
                </tr>
                <tr *ngIf="item['IsCorridor']">
                  <td>{{ 'ADMIN_LTI.GATEWAYS.BODY.MAX' | translate }}</td>
                  <td class="text-right" *ngFor="let year of item.YearlyValues">
                    {{ formatValue(item, getMaxValue(item, year), 1) }}
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              class="consultationTypeTable"
              *ngIf="item['ConsultationType'] == 'Average'"
            >
              <!-- AVERAGE -->
              <thead>
                <tr>
                  <th>{{ 'ADMIN_LTI.GATEWAYS.BODY.YEAR' | translate }}</th>
                  <th *ngFor="let x of item.YearlyValues">{{ x.Year }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ 'ADMIN_LTI.GATEWAYS.BODY.YEARLY_VALUE' | translate }}
                  </td>
                  <td class="text-right" *ngFor="let x of item.YearlyValues">
                    <input
                      [(ngModel)]="x.TargetValue"
                      type="number"
                      id="Value_{{ x.Year }}"
                      [disabled]="!isEditable(x.Year)"
                      class="form-control input_small"
                      [ngClass]="{ invalid: x.hasError }"
                      (ngModelChange)="onValueChange(x)"
                    />
                  </td>
                </tr>
                <tr *ngIf="errorMessage" class="errorMessage">
                  <td [attr.colspan]="item.YearlyValues.length + 1">
                    <div class="errorConsultation">
                      <i class="fa fa-exclamation text-danger"></i>
                      {{ errorMessage }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    {{ 'ADMIN_LTI.GATEWAYS.BODY.TARGET_VALUE' | translate }}
                  </td>
                  <td class="text-right" *ngFor="let year of item.YearlyValues">
                    {{ formatValue(item, getTargetValue(item, year), 1) }}
                  </td>
                </tr>
                <tr *ngIf="item['IsCorridor']">
                  <td>{{ 'ADMIN_LTI.GATEWAYS.BODY.MIN' | translate }}</td>
                  <td class="text-right" *ngFor="let year of item.YearlyValues">
                    {{ formatValue(item, getMinValue(item, year), 1) }}
                  </td>
                </tr>
                <tr *ngIf="item['IsCorridor']">
                  <td>{{ 'ADMIN_LTI.GATEWAYS.BODY.MAX' | translate }}</td>
                  <td class="text-right" *ngFor="let year of item.YearlyValues">
                    {{ formatValue(item, getMaxValue(item, year), 1) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </accordion-group>
  </accordion>

  <div class="gateway-weigth">
    <div class="gateway-weigth-value">{{ getWeight() }}%</div>
  </div>

  <div class="gateway-delete" *ngIf="!IsActive">
    <i class="fa fa-trash pointer" (click)="removeItem()"></i>
  </div>
</div>
